import CredoraRedirect from "./CredoraRedirect";
import CredoraAccessGate from "../Components/Credora/Common/CredoraAccessGate";
import { credoraAppRoutes } from "./credoraRouteRegistry";
import { MENUITEMS } from "../Layout/Sidebar/Menu";
import { collectMenuPaths } from "../Layout/Sidebar/collectMenuPaths";

const credoraRedirectRoutes = collectMenuPaths(MENUITEMS).map((basePath) => ({
  path: `${process.env.PUBLIC_URL || ""}${basePath}`,
  Component: <CredoraRedirect basePath={basePath} />,
}));

export const credoraRoutes = [
  ...credoraRedirectRoutes,
  ...credoraAppRoutes.map(({ path, element }) => ({
    path,
    Component: <CredoraAccessGate>{element}</CredoraAccessGate>,
  })),
];
